module.exports = __webpack_public_path__ + "img/pain-spot-11.78fc27ef.svg";